import { Box, BoxProps, styled } from '@mui/material';
import { FC } from 'react';

// Outer card surface (theme-aware) — holds the toolbar, table and pagination as one unit,
// matching the Mantis MainCard look. `overflow: hidden` clips children to the rounded corners.
export const TableCardWrap = styled(Box as FC<BoxProps>)(({ theme }) => ({
	width: '100%',
	display: 'flex',
	flexDirection: 'column',
	backgroundColor: theme.vars.palette.background.paper,
	border: `1px solid ${theme.vars.palette.divider}`,
	borderRadius: 10,
	overflow: 'hidden'
}));
